import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { CommonService } from "../../../core/service/common-service/common.service";
import { ToastrService } from "ngx-toastr";


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private router: Router,
        private commonService: CommonService,
        private toastr: ToastrService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if (err.status === 401) {
                let userId = localStorage.getItem("userId");
                this.getSigninUpdate(userId, 'N', '0');
                // auto logout if 401 response returned from api
                localStorage.clear();
                this.router.navigate(['/login']);
                location.reload(true);
            }

            const error = err.error && err.error.message || err.statusText;
            return throwError(error);
        }))
    }

    getSigninUpdate(user: string, flag: string, count: string): void {
        this.commonService.getSigninUpdate(user, flag, count).subscribe(res => {
          if (res['responseCode'] == 0) {
          } else {
            //this.spinner = false;
            //this.toastr.error(res['message'], "Error");
          }
        }, error => {
          //this.spinner = false;
          this.toastr.error(error, "Error");
        });
      }
}
